





































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { Inject } from '@/core/helpers/vue-inversify-decorator';
import {
    CONTRACTS,
    FetchServiceContract,
    AuthServiceContract,
    SignInType,
    DialogButton,
    WindowsServiceContract,
    SettingsChangeServiceContract,
} from '@/core/contracts';
import { ContextsState, UserState, SettingsState } from '@/store';
import Page from '@/core/components/controls/Page.vue';

import { ClientSettingTypeEnum, User, ContextUser } from '@/dto';
import { DxSelectBox } from 'devextreme-vue';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxButton from 'devextreme-vue/button';
import DxTreeView from 'devextreme-vue/tree-view';
import ArrayStore from 'devextreme/data/array_store';
import { copyToClipboard, NoCache } from '@/core/helpers';
import { localize } from '@/core/filters';
import container from '@/container';
import UserSettingsComponent from './components/UserSettingsComponent.vue';
import { result } from 'lodash';
import CultureComponent from './components/CultureComponent.vue';

@Component({
    components: {
        UserSettingsComponent,
        DxDropDownBox,
        DxTreeView,
        DxSelectBox,
        CultureComponent,
        DxButton,
    },
})
export default class UserSettingsPage extends Page {
    @Prop() public args: any | undefined;

    public get currentUser() {
        return UserState.current;
    }

    public get serverSettings() {
        return SettingsState.server;
    }

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.AuthService)
    private _authService?: AuthServiceContract;
    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;

    private async mounted() {}

    /**
     * Vue created lifecycle event handler
     * Creates SettingsChangeService instance and stores in the settings store
     */
    private created(): void {}

    private logout() {
        this._authService!.signOut(SignInType.Default);
    }

    private help() {
        window.open(this.serverSettings!.helpLink);
    }

    @NoCache
    private get settingsChangeService(): SettingsChangeServiceContract {
        return SettingsState.changeService!;
    }
}
